var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_col scroll",staticStyle:{"padding":"16px","padding-bottom":"150px"},attrs:{"id":"scroll"},on:{"scroll":function($event){return _vm.scrollHandler()}}},[_c('StoreList',{attrs:{"dataList":_vm.listData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }